import { render, staticRenderFns } from "./assessmentTemplate.vue?vue&type=template&id=71a8d185&scoped=true&"
import script from "./assessmentTemplate.vue?vue&type=script&lang=js&"
export * from "./assessmentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./assessmentTemplate.vue?vue&type=style&index=0&id=71a8d185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8d185",
  null
  
)

export default component.exports